import { request } from "./apiClient";

export interface ApiKey {
  id: string;
  name: string;
  createdAt: string;
}

export interface ApiKeyCreated extends ApiKey {
  key: string;
}

export async function fetchApiKeys(): Promise<ApiKey[]> {
  return request<ApiKey[]>("/api-keys");
}

export async function createApiKey(name: string): Promise<ApiKeyCreated> {
  return request<ApiKeyCreated>("/api-keys", {
    method: "POST",
    data: { name },
  });
}

export async function deleteApiKey(id: string): Promise<void> {
  await request<void>(`/api-keys/${id}`, { method: "DELETE" });
}
